// import { BrowserModule } from '@angular/platform-browser';
import { Component, OnInit, Input, Injectable, PLATFORM_ID, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import moment from 'moment';
// models
import { ModalData } from '../../models/modal.interface';
import { AdminFilters } from '../../models/admin-filters.interface';
import { AddQuestionAnswerRequest } from '../../models/question-answer.interface';
// services
import { ErrorHandler } from '../../services/error-handler.service';
import { CompleteBookingService } from '../../../my-account/services/complete-bookings.service';
import { AddQuestionAnswerService } from '../../services/add-question-answer.service';
import { CollectionService } from '../../../booking/services/collection.service';
import { FlightDetailsService } from '../../services/flight-details.service';
import { PriceService } from '../../../booking/services/price.service';
import { AppStateService } from '../../services/app-state.service';
import { BookingService } from '../../../booking/services/booking.service';
import { DataStorageService } from '../../services/data-storage.service';
import { LoginService } from '../../services/login.service';
import { HttpClient } from '@angular/common/http';
import { MilesAndMore } from '../../../booking/services/miles-n-more.service';
// shared functions
import Shared from '../../../booking/shared/shared';
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, switchMap, take } from 'rxjs/operators';
// globals
import { MILES_LOGIN_URL, EMAIL_PATTERN, ADD_IMAGE, API_PATH } from '../../../shared/globals';



import { COUNTRY_CODES } from '../../globals';
import { BookerItem } from '../../../booking/models/booking.interface';
import { CopyService } from '../../services/app-copy.service';
import { BookingDetailsService } from '../../../my-account/services/booking-details.service';
import { forkJoin } from 'rxjs';

declare var ga: any;
declare var zE: any;
declare var exponea: any;

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  providers: [AppStateService, LoginService]
})

@Injectable({
  providedIn: 'root',
})
export class ModalComponent implements OnInit, OnDestroy {

  @ViewChild('form') form;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Input()
  dataLoaded: boolean = false;

  public modalData: ModalData;
  public modalList: Array<any> = [];
  public destinationSelected: Boolean = false;
  public filtersDisabled: Boolean = true;
  public showDateError: Boolean = false;
  public filtersSelected;
  public cancelReasons: Array<string> = [
    'Can’t get my boarding pass',
    'I’ve changed my mind',
    'I need to amend my booking',
    'My travel plans or flight has changed',
    'Other'
  ];
  public subReasons = {};
  public cancelReasonSelected = null;
  public selectedCancelSubReason = null;
  public cancelReasonSubmitted: Boolean = false;
  public cancelReasonCustom: string = '';
  public showEmailSent: Boolean = false;
  public showLoader: Boolean = false;
  public uploadedImages: any[] = [];
  public uploadedImagesError: boolean = false;
  public uploadedImagesSizeError: boolean = false;
  public uploadedImagesFormatError: boolean = false;
  public languageCode: string = 'en';


  public appCopyModal: any;
  public fetchedData: any;
  public dataChanged = false;
  public emailUpdaed: boolean = false;
  public buttonDisabled = true;
  public user: any;
  public minDate = new Date();
  public maxDate = null;
  public disableDates = [];
  public showCanncelReasonsAfterFixed: Boolean = false;
  public cutOffTimeWindow = '';
  public inTheCoolingPeriod = false;
  public collectionTimePassed = false;

  private _bookingInitSubscription: Subscription;
  private _modalSubscription: Subscription;
  private _routeParamsSubscription: Subscription;
  private _emailSentSubscription: Subscription;
  private _bookingDetailsSubscription: Subscription;
  private _copyInitSubscription: Subscription;
  private _userSubscription: Subscription;
  private occReasonAdded: boolean = false;
  private phoneNumberSubject = new Subject<string>();
  public validationResult: any;
  public scrollPosition = 0;
  public airlineIssue: boolean = false;


  constructor(
    private _completeBookingService: CompleteBookingService,
    private _errorService: ErrorHandler,
    private _addQuestionAnswerService: AddQuestionAnswerService,
    private _collectionService: CollectionService,
    private _flightDetailsService: FlightDetailsService,
    private _pricingService: PriceService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _appStore: Store<AppState>,
    private _appStateService: AppStateService,
    private _bookingService: BookingService,
    private _bookingDetailsService: BookingDetailsService,
    private _dataStorageService: DataStorageService,
    private _milesAndMoreService: MilesAndMore,
    private _loginService: LoginService,
    private _copyService: CopyService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Subscribe to the phoneNumberSubject observable
    this.phoneNumberSubject.pipe(
      debounceTime(1000),  // Adjust debounce time as needed
      switchMap(async (value) => this._bookingService.validatePhoneNumber(value))
    ).subscribe(result => {
      this.validationResult = result;
      // Handle the result here (e.g., update form control errors or UI)
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {

      this._bookingInitSubscription = this._appStore.select('userReducer')
        .subscribe((res: any) => {
          if (res.userDetails.userLoggedIn && !this.occReasonAdded && (res.userDetails.userRole !== 'CUSTOMER' && res.userDetails.userRole !== 'GUEST' && res.userDetails.userRole && 'PARTNER')) {
            this.occReasonAdded = true;
            this.cancelReasons = [
              'Can’t get boarding pass',
              'Can’t amend as needed',
              'Can’t complete declaration',
              'Technical issue',
              'Logistics request',
              'Duplicate',
              'Customer changed mind',
              'OCC - Operations Capacity Cancellation',
              'Medical issues',
              'Driver behaviour',
              'Other'
            ];
            this.subReasons = {
              'Can’t amend as needed': [
                'Number of bags',
                'Flight number',
                'Timeslot',
              ],
              'OCC - Operations Capacity Cancellation': [
                'Logistics requested',
                'Airport operational issue',
                'Logistics/airport/tech issues',
                'Driver issues and/or sickness',
                'Other'
              ],
              'Logistics request': [
                'Passenger not present',
                'Passenger changed their mind',
                'Flight cancelled or rescheduled',
                'Passenger is present, but not ready to hand over bags',
                'Passenger expected us on a different day',
                'Driver unable to park / passenger refused to meet driver',
                'Passenger has no valid passport or ID',
                'Tech issue that allowed customer to book at short notice',
                'Road closure'
              ]
            }
          }
        })

      this._modalSubscription = this._errorService.modalItem$
        .subscribe(modalItem => {
          if (modalItem === 'remove') {
            this.closeModal();
            return;
          }
          this.create(modalItem);
        });

      this._emailSentSubscription = this._loginService.resendEmailSent$
        .subscribe(emailSent => {
          if (emailSent.error) {
            this.handleErrors();
            return;
          }

          this.showEmailSent = emailSent;
          if (this.showEmailSent) {
            this.closeModal();
            this.handleErrors();
            const data = {
              text: 'Email sent!',
              type: 'info',
              icon: 'alert',
              sticky: false
            };

            this._errorService.handleCustomInfo(data);
          }

        },
          err => console.log(err));
    }



    this._copyInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        if (res.copyLoaded) {
          if (isPlatformBrowser(this.platformId)) {
            this.getCopy();
          }
        }
      });

    this._userSubscription = this._appStore.select('userReducer')
      .subscribe((user: any) => {
        this.user = user;
      });

  }

  dateChanged(e) {
    this.showLoader = true;
    this._bookingDetailsService.flightChangeClick$.next(e);
  }

  create(data: any) {
    this.inTheCoolingPeriod = false;
    this.collectionTimePassed = false;
    this.airlineIssue = false;
    // Reset uploaded images and errors when opening modal
    this.languageCode = this.getState(this._appStore).copyReducer.languageCode;
    if (data?.modalType === 'deleteBooking') {
      const d = moment(data.data.collectionDateTimeUTC);
      // if the data.data.collectionDateTimeUTC has passed
      this.collectionTimePassed = moment().isAfter(d);
      this.cutOffTimeWindow = d.subtract(data.data.cutOffTimeWindow, 'minutes').format('YYYY-MM-DDTHH:mm');
      if (data.productPlan === "Semi Flex") {
        this.inTheCoolingPeriod = moment().diff(moment(data.data.bookingJourneyCreatedDateTime), 'hours') < data.data.coolingPeriod;
        if (this.inTheCoolingPeriod) {
          const d = moment(data.data.bookingJourneyCreatedDateTime);
          this.cutOffTimeWindow = d.add(data.data.coolingPeriod, 'hours').format('YYYY-MM-DDTHH:mm');
        }
      }
    }

    this.uploadedImages = [];
    this.uploadedImagesError = false;
    this.uploadedImagesSizeError = false;
    this.uploadedImagesFormatError = false;

    if (this.modalList.length > 0) {
      this.modalList.splice(0, 1);
    }
    if (data.productPlan === undefined || data.productPlan !== 'Fixed') {
      this.showCanncelReasonsAfterFixed = true
    }
    this.modalList.push(data);
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');

    if (this.modalData?.modalType !== 'savePereferences') {
      this.sendGAData('CancelRequest');
    }

    this.scrollPosition = window.scrollY;
  }

  getCopy() {
    const panelHeaderCopy = this._copyService.getCopyBySection(
      'OTHER',
      'Modal',
      ['panelHeader']
    );

    this.appCopyModal = {
      panelHeader: panelHeaderCopy[0],
    };
  }

  closeModal(e?, modalType?: string) {
    this.showCanncelReasonsAfterFixed = false;
    let email_check: any = true;
    if (!this.form === undefined) {
      if (this.form.value.hasMarketingEnrolment === true) {
        email_check = 'accept'
      } else {
        email_check = 'reject'
      }
    }

    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.modalList.splice(0, 1);

      if (modalType !== 'savePereferences') {
        this.sendGAData('CancelChangeMind', this.cancelReasons[this.cancelReasonSelected]);
        this.cancelReasonSelected = null;
        this.cancelReasonSubmitted = false;
      }

      window.scrollTo(0, this.scrollPosition);
    }
  }

  removeClasses() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.closeModal();
    }
  }

  sendGAData(action?: string, label?: string) {
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = location.pathname;
      const gaAction = action;
      const gaLabel = label ? label : currentUrl;

      ga('send', 'event', 'Funnel', gaAction, gaLabel);
      console.log('send', 'event', 'Funnel', gaAction, gaLabel);
    }
  }

  confirmCancelFromFixed() {
    this.showCanncelReasonsAfterFixed = true;
  }

  submitCancelReason() {
    this.cancelReasonSubmitted = true;
    this.sendGAData('CancelContinue', this.cancelReasons[this.cancelReasonSelected]);
  }

  handleErrors() {
    this.showLoader = false;
  }

  resendClickHandler() {
    this.showLoader = true;
    const data = this.modalList[0]
    this._loginService.resendComms(data.email, data.bookingReference);
  }

  // booking delete modal
  async deleteBooking(val, bookingRef, journeyRef, userToken) {
    const questionAnswerRequest: AddQuestionAnswerRequest = {
      bookingReference: bookingRef,
      bookingJourneyReference: journeyRef,
      questionAnswer: [{
        question: 'Why are you cancelling?',
        answer: ''
      }],
      client: 2,
      category: 1
    };

    if (this.cancelReasonSelected !== this.cancelReasons.length - 1) {
      let subReason = this.selectedCancelSubReason !== null ? ` - ${this.subReasons[this.cancelReasons[this.cancelReasonSelected]][this.selectedCancelSubReason]}` : '';
      subReason = val.cancelReasonCustom ? subReason + ` - ${val.cancelReasonCustom}` : subReason;
      questionAnswerRequest.questionAnswer[0].answer = this.cancelReasons[this.cancelReasonSelected] + subReason;
      this.sendGAData('CancelConfirm', this.cancelReasons[this.cancelReasonSelected] + subReason);
    } else {
      questionAnswerRequest.questionAnswer[0].answer = val.cancelReasonCustom;
      this.sendGAData('CancelConfirm', val.cancelReasonCustom);
    }


    const modal = this.modalList[0];
    if ((this.cancelReasonSelected === 0 || this.cancelReasonSelected === 3) && !this.occReasonAdded) {
      // Upload images if any
      if (this.uploadedImages.length > 0) {
        await this.uploadImages(bookingRef, journeyRef, userToken);
      } else {
        this.uploadedImagesError = true;
        return;
      }
    }

    this._addQuestionAnswerService.addQuestionAnswer(questionAnswerRequest, userToken);
    this._completeBookingService.deleteBookingItem$.next({ bookingRef, reason: questionAnswerRequest.questionAnswer[0].answer });
    this.closeModal();
  }

  // flight direction modal
  goToQuote() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this._router.navigate(['quote']);
    }
  }

  continueBooking() {
    if (isPlatformBrowser(this.platformId)) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.remove('modal-open');
      this.closeModal();
    }
  }

  // admin filters
  clearFilters() {

    this.filtersDisabled = true;

    this.filtersSelected = {
      airport: '',
      type: '',
      startDateDay: null,
      startDateMonth: null,
      startDateYear: null,
      endDateDay: null,
      endDateMonth: null,
      endDateYear: null,
      showPast: false,
      showCancelled: false
    };

    const selectedFilterObj: AdminFilters = {
      startDateTimeUTC: null,
      endDateTimeUTC: null,
      addOnProductType: [],
      airport: [],
      bookingJourneyActivity: 1,
      showCancelledBookings: false,
    };
    this._completeBookingService.setAppliedFilters(this.filterNullValues(selectedFilterObj));
    this.closeModal();

  }

  setAdminFilters() {

    // let selectedFilterObj = null;
    const selectedFilterObj: AdminFilters = {
      startDateTimeUTC: null,
      endDateTimeUTC: null,
      addOnProductType: [],
      airport: [],
      bookingJourneyActivity: 0,
      showCancelledBookings: false
    };

    this.showDateError = false;

    // if no filters selected
    if (typeof this.filtersSelected === 'undefined') {
      return;
    }

    if (
      this.filtersSelected.startDateDay !== null && this.filtersSelected.endDateDay === null ||
      this.filtersSelected.startDateDay === null && this.filtersSelected.endDateDay !== null
    ) {
      this.filtersDisabled = true;
      this.showDateError = true;
      return;
    }

    if (
      this.filtersSelected.startDateDay !== null &&
      this.filtersSelected.startDateMonth !== null &&
      this.filtersSelected.startDateYear !== null
    ) {
      selectedFilterObj.startDateTimeUTC = Shared.multiDateFormat(
        this.filtersSelected.startDateDay, this.filtersSelected.startDateMonth, this.filtersSelected.startDateYear);

      selectedFilterObj.startDateTimeUTC = selectedFilterObj.startDateTimeUTC + 'T12:00:00Z';
    }

    if (
      this.filtersSelected.endDateDay !== null &&
      this.filtersSelected.endDateMonth !== null &&
      this.filtersSelected.endDateYear !== null
    ) {
      selectedFilterObj.endDateTimeUTC = Shared.multiDateFormat(
        this.filtersSelected.endDateDay, this.filtersSelected.endDateMonth, this.filtersSelected.endDateYear);

      selectedFilterObj.endDateTimeUTC = selectedFilterObj.endDateTimeUTC + 'T12:00:00Z';
    }

    if (this.filtersSelected.airport !== '') {
      selectedFilterObj.airport.push(this.filtersSelected.airport);
    }

    if (this.filtersSelected.type !== '') {
      selectedFilterObj.addOnProductType.push(this.filtersSelected.type);
    }

    selectedFilterObj.showCancelledBookings =
      typeof this.filtersSelected.showCancelled !== 'undefined' ? this.filtersSelected.showCancelled : false;

    if (this.filtersSelected.showPast) {
      selectedFilterObj.bookingJourneyActivity = 0;
    } else {
      selectedFilterObj.bookingJourneyActivity = 1;
    }

    this._completeBookingService.setAppliedFilters(this.filterNullValues(selectedFilterObj));
    this.closeModal();
  }

  filterFormValues(filters) {
    this.filtersSelected = filters;
    this.filtersDisabled = false;
  }

  filterNullValues(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName].length === 0) {
        delete obj[propName];
      }
    }
    return obj;
  }

  // show manual flight search
  showFlightSearch(searchType) {
    this._flightDetailsService.showFlightSearch$.next(searchType);
    this.closeModal();
  }

  deleteCard(ref, id, token) {
    const successMessage = this.appCopyModal.panelHeader['cardDeletedText' + this.selectedLanguage]
    this._pricingService.removeSavedCard(ref, id, token, successMessage);
    this.closeModal();
  }

  milesLoginRedirect() {
    const milesLoginUrl = MILES_LOGIN_URL;
    const callbackUrl = location.href.split('?')[0];
    this._milesAndMoreService.milesLoginRedirect(milesLoginUrl, callbackUrl);
  }

  handleChatClick() {
    zE.activate();
  }

  resetReasons() {
    this.cancelReasonSelected = null;
    this.selectedCancelSubReason = null;
    this.cancelReasonSubmitted = false;
  }

  onReasonUpdate(index: number) {
    if (this.cancelReasons[index] === 'My travel plans or flight has changed') {
      this.airlineIssue = true;
    } else {
      this.airlineIssue = false;
    }
    this.selectedCancelSubReason = null;
    this.cancelReasonCustom = '';
  }

  onFileSelected(event: any) {
    this.uploadedImagesError = false;
    this.uploadedImagesSizeError = false;
    this.uploadedImagesFormatError = false;
    const files = event.target.files;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/svg+xml', 'application/pdf'];
    console.log('Files selected:', files.length);
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      console.log(`File ${i}: type=${file.type}, size=${file.size} bytes, name=${file.name}`);
      if (allowedTypes.includes(file.type)) {
        if (file.size > 5242880) {
          console.log(`File ${i} size ${file.size} > 5MB, setting size error`);
          this.uploadedImagesSizeError = true;
        } else {
          console.log(`File ${i} valid (allowed type), adding to uploadedImages`);
          if (file.type.startsWith('image/') && file.type !== 'image/svg+xml') {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              this.uploadedImages.push({
                file: file,
                preview: e.target.result
              });
            };
            reader.readAsDataURL(file);
          } else {
            // For PDFs and SVGs, no preview
            this.uploadedImages.push({
              file: file,
              preview: null
            });
          }
        }
      } else {
        console.log(`File ${i} type ${file.type} not supported, setting format error`);
        this.uploadedImagesFormatError = true;
      }
    }
  }

  removeImage(index: number) {
    this.uploadedImages.splice(index, 1);
  }

  async uploadImages(bookingReference: string, bookingJourneyReference: string, userToken: string): Promise<void> {
    if (this.uploadedImages.length === 0) return;

    const uploadObservables = this.uploadedImages.map(image =>
      this._bookingDetailsService.uploadImage(image.file, bookingReference, bookingJourneyReference, userToken)
    );

    try {
      await forkJoin(uploadObservables).toPromise();
    } catch (error) {
      console.error('Error uploading images:', error);
    }
  }

  getState(appState: Store<AppState>): AppState {
    let s;
    this._appStore.pipe(take(1)).subscribe((appState: AppState) => {
      s = appState;
    });
    return s;
  }

  ngOnDestroy(): void {
    if (this._bookingInitSubscription) {
      this._bookingInitSubscription.unsubscribe();
    }
    if (this._userSubscription) { this._userSubscription.unsubscribe(); }
    this._copyInitSubscription.unsubscribe();
    if (this._bookingDetailsSubscription) { this._bookingDetailsSubscription.unsubscribe(); }
    if (this._modalSubscription) { this._modalSubscription.unsubscribe(); }
    if (this._routeParamsSubscription) { this._routeParamsSubscription.unsubscribe(); }
    // this._emailSentSubscription.unsubscribe();
  }
}




